import React, { useState, useCallback } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import debounce from 'debounce-promise';
import { DEBOUNCE_DELAY, defaultPager } from '../constants';
import { useTranslation } from 'react-i18next';
import { Button } from '@totalsoft/rocket-ui';
import PaginationWrapper from 'components/common/PaginationWrapper';

const BrowserContainer = ({ Container, onTextFieldChange, setOpenModal, partnerTypeId }) => {
  const [t] = useTranslation();
  const [pager, setPager] = useState(defaultPager);
  const [totalCount, setTotalCount] = useState(0);
  const pagerDebounced = debounce(setPager, DEBOUNCE_DELAY);

  const handleTotalCount = count => {
    setTotalCount(count);
  };

  const handleRefresh = useCallback(() => {
    setPager({
      ...pager,
      page: 1
    });
  }, [pager, setPager]);

  const onClose = () => {
    setOpenModal(false);
  };

  const onChangePage = page => {
    pagerDebounced(previousState =>
      Object.assign(
        {},
        {
          ...previousState,
          page: ++page
        }
      )
    );
  };

  const onChangePageSize = pageSize => {
    if (pageSize === pager.pageSize) return;
    pagerDebounced(previousState =>
      Object.assign(
        {},
        {
          ...previousState,
          pageSize: pageSize,
          page: 1
        }
      )
    );
  };

  return (
    <>
      <Grid container sx={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'visible', p: 4, pb: 1 }}>
        <Grid item xs={12}>
          <Container
            pager={pager}
            onTextFieldChange={onTextFieldChange}
            onTotalCountChange={handleTotalCount}
            onRefresh={handleRefresh}
            setOpenModal={setOpenModal}
            partnerTypeId={partnerTypeId}
          ></Container>
        </Grid>
      </Grid>
      <Grid container justifyContent='space-between' alignItems='center' px={4} py={1}>
        <Grid item>
          <Button variant='outlined' onClick={onClose}>
            {t('Close')}
          </Button>
        </Grid>
        <Grid item>
          <PaginationWrapper
            count={totalCount}
            pageSize={pager.pageSize}
            page={pager.page}
            onRowsPerPageChange={onChangePageSize}
            onPageChange={onChangePage}
            onRefresh={handleRefresh}
          />
        </Grid>
      </Grid>
    </>
  );
};

BrowserContainer.propTypes = {
  Container: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  partnerTypeId: PropTypes.number
};

export default BrowserContainer;
